import { render } from "./RegisterInstructionsSchoolManager.vue?vue&type=template&id=69e4e7c3"
import script from "./RegisterInstructionsSchoolManager.vue?vue&type=script&lang=js"
export * from "./RegisterInstructionsSchoolManager.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__